/* eslint-disable @typescript-eslint/no-var-requires */
const packageMeta = require('./package.json')
const seamlessRc = require('./../../.seamlessrc.json')

const NAME = packageMeta.name.split('/')[1]
const TENANT = seamlessRc.tenantId
const pluginPath = `/${TENANT}-${NAME}`
const fileName = `${TENANT}-${NAME}`

module.exports = {
  manifestVersion: '2.0',
  name: `${fileName}`,
  version: packageMeta.version,
  config: {
    hasCss: false,
    files: {
      scripts: [
        {
          url: `${pluginPath}/${fileName}-${packageMeta.version}/${fileName}.vendors~${fileName}.min.min.js`,
          attrs: {
            type: 'module', // vendor
          },
        },
        {
          url: `${pluginPath}/${fileName}-${packageMeta.version}/${fileName}.min.js`,
          attrs: {
            type: 'module', // component
          },
        },
        {
          url: `${pluginPath}/${fileName}-${packageMeta.version}/${fileName}.vendors~${fileName}.es5.min.js`,
          attrs: {
            nomodule: '', //vendor old browsers remove its not supported
          },
        },
        {
          url: `${pluginPath}/${fileName}-${packageMeta.version}/${fileName}.es5.min.js`,
          attrs: {
            nomodule: '', //component old browsers remove its not supported
          },
        },
      ],
    },
    dependencies: {
      oneweb: '2.0',
    },
    integrationType: 'webcomponent',
    marketAvailability: [
      {
        language: 'de',
        country: 'AT',
      },
      {
        language: 'en',
        country: 'AU',
      },
      {
        language: 'nl',
        country: 'BE',
      },
      {
        language: 'fr',
        country: 'BE',
      },
      {
        language: 'bg',
        country: 'BG',
      },
      {
        language: 'de',
        country: 'CH',
      },
      {
        language: 'fr',
        country: 'CH',
      },
      {
        language: 'it',
        country: 'CH',
      },
      {
        language: 'en',
        country: 'CY',
      },
      {
        language: 'cs',
        country: 'CZ',
      },
      {
        language: 'de',
        country: 'DE',
      },
      {
        language: 'da',
        country: 'DK',
      },
      {
        language: 'et',
        country: 'EE',
      },
      {
        language: 'es',
        country: 'ES',
      },
      {
        language: 'fi',
        country: 'FI',
      },
      {
        language: 'fr',
        country: 'FR',
      },
      {
        language: 'en',
        country: 'GB',
      },
      {
        language: 'el',
        country: 'GR',
      },
      {
        language: 'hr',
        country: 'HR',
      },
      {
        language: 'hu',
        country: 'HU',
      },
      {
        language: 'en',
        country: 'IE',
      },
      {
        language: 'en',
        country: 'IN',
      },
      {
        language: 'it',
        country: 'IT',
      },
      {
        language: 'en',
        country: 'JP',
      },
      {
        language: 'ja',
        country: 'JP',
      },
      {
        language: 'ko',
        country: 'KR',
      },
      {
        language: 'de',
        country: 'LI',
      },
      {
        language: 'lt',
        country: 'LT',
      },
      {
        language: 'de',
        country: 'LU',
      },
      {
        language: 'fr',
        country: 'LU',
      },
      {
        language: 'lv',
        country: 'LV',
      },
      {
        language: 'en',
        country: 'MT',
      },
      {
        language: 'en',
        country: 'MY',
      },
      {
        language: 'nl',
        country: 'NL',
      },
      {
        language: 'no',
        country: 'NO',
      },
      {
        language: 'en',
        country: 'NZ',
      },
      {
        language: 'pl',
        country: 'PL',
      },
      {
        language: 'pt',
        country: 'PT',
      },
      {
        language: 'ro',
        country: 'RO',
      },
      {
        language: 'sv',
        country: 'SE',
      },
      {
        language: 'en',
        country: 'SG',
      },
      {
        language: 'sl',
        country: 'SI',
      },
      {
        language: 'sk',
        country: 'SK',
      },
      {
        language: 'en',
        country: 'TH',
      },
      {
        language: 'th',
        country: 'TH',
      },
      {
        language: 'zh',
        country: 'TW',
      },
      {
        language: 'en',
        country: 'XA',
      },
      {
        language: 'en',
        country: 'XD',
      },
      {
        language: 'en',
        country: 'ZA',
      },
    ],
  },
  aemComponentConfig: {
    title: 'cmic notifications-hub-ui Web Component',
    description: packageMeta.description,
    componentGroup: 'Generic NG - Content',
    productPrefix: seamlessRc.tenantId,
    tagNameWithoutPrefix: 'notifications-hub-ui',
    dialog: [],
    globalComponent: true,
  },
}
